import React from 'react';
import { opsConstants, alertConstants } from "../constants";
import { opsService } from "../services/ops.service";

export const opsActions = {
    getAirtableReconciliationReport
  };

function getAirtableReconciliationReport(org_id) {
    return (dispatch) => {
      dispatch(fetchAlert("fetching report..."));
      dispatch(reportRequest(org_id));
  
      opsService.getAirtableReconciliationReport(org_id).then(
        (report) => {
          dispatch(clearAlert());
          dispatch(success(report));
        },
        (error) => {
          dispatch(clearAlert());
          dispatch(failure(error));
        }
      );
    };
    function fetchAlert(message) {
        return { type: alertConstants.SPINNER, message };
      }
      function reportRequest(org_id) {
        return { type: opsConstants.AIRTABLE_RECONCILIATION_REPORT_REQUEST, org_id };
      }
      function clearAlert() {
        return { type: alertConstants.CLEAR };
      }
      function success(report) {
        return { type: opsConstants.AIRTABLE_RECONCILIATION_REPORT_SUCCESS, report };
      }
      function failure(message) {
        return { type: opsConstants.AIRTABLE_RECONCILIATION_REPORT_FAILURE, message };
      }
    }    